import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { AppliedBranchDetails, BankInDetails } from '../apply-asset-request/apply-asset-request.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { GlobalSearchCustomerComponent } from 'src/app/Others/global-search-customer/global-search-customer.component';
import { GlobalCustomer } from 'src/model/globalCustomer.model';
import { LoanAdapter, LoanService } from 'src/services/loan.service';
import { Enums } from 'src/app/Shared/enums';
import { Loan } from 'src/model/loan.model';
import { ALERT_TYPE } from 'src/app/constants';
import { Company } from 'src/model/company.model';
import { AddBankInAccountComponent } from 'src/app/AddThings/add-bank-in-account/add-bank-in-account.component';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { MessageClipboardComponent } from 'src/app/MessageClipboard/message-clipboard/message-clipboard.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SheetDetails } from 'src/model/assetSheetRequestDetails.model';
import { AssetSheetRequestService } from 'src/services/asset-sheet-request.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'src/services/company.service';
import { FinanceAccountService } from 'src/services/finance-account.service';
import { BusinessService } from 'src/services/business.service';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-asset-return-cash',
	standalone: false,
	templateUrl: './asset-return-cash.component.html',
	styleUrl: './asset-return-cash.component.scss',
	providers: [DatePipe]
})
export class AssetReturnCashComponent implements OnInit {
	@Input() loggedInUser: string;
	@Input() companyCode: string;
	@Input() companyId: number;

	protected sharedService = inject(SharedService);
	protected loanService = inject(LoanService);
	protected enums = inject(Enums);
	protected loanAdapter = inject(LoanAdapter);
	protected cdr = inject(ChangeDetectorRef);
	protected sheetRequestService = inject(AssetSheetRequestService);
	protected activeModal = inject(NgbActiveModal);
	protected companyService = inject(CompanyService);
	protected financeAccountService = inject(FinanceAccountService);
	protected businessService = inject(BusinessService);
	protected datepipe = inject(DatePipe);

	protected returnOptions = ['Customer', 'Office Cash'];
	protected selectedReturnOpt: string;
	protected amount: number = 0;
	protected returnBank: string;
	protected defaultBank: FinanceAccount;
	protected remark: string;
	protected branchDistributionList: AppliedBranchDetails[] = new Array();
	protected needRefund = false;
	protected refundAmount = 0;
	protected bankInAccount: CustomerAccount | undefined;

	protected selectedCustomer: GlobalCustomer;
	protected previousEPFLoans: Loan[] = new Array();
	protected disableSubmit = false;

	protected finalMessage: string = '';
	protected uuid = '';
	protected isShared = false;

	async ngOnInit() {
		// should return exact 1 result only
		const business = await this.businessService.getAllBusinesses({ companyId: this.companyId });
		const financeAccts = await this.financeAccountService.getBusinessFinanceAccounts(business[0].Id);

		this.defaultBank = financeAccts[0];
		this.returnBank = this.defaultBank.Description;
	}

	addLoggedInCompanyIntoList() {
		this.branchDistributionList = [];

		if (this.isShared) {
			this.branchDistributionList.push({
				appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
				amount: 0
			});
		} else
			this.branchDistributionList.push({
				appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
				amount: this.amount
			});
	}

	searchCustomerAndFillIn() {
		this.resetEverything();

		const modalRef = this.sharedService.openModal(GlobalSearchCustomerComponent, 'largeModal');
		modalRef.componentInstance.isGlobal = this.sharedService.isAdmin() || this.sharedService.isBossAccount();
		modalRef.componentInstance.needRedirect = false;

		modalRef.componentInstance.passEntry.subscribe((entry: any) => {
			this.selectedCustomer = entry;
			this.getCustomerLoanInfo(this.selectedCustomer);

			this.remark = this.selectedCustomer.Name + '(' + this.selectedCustomer.ICNumber + ')';
		});
	}

	async getCustomerLoanInfo(customer: GlobalCustomer) {
		this.previousEPFLoans = [];
		this.previousEPFLoans = await this.loanService.getCustomerLoans(customer.CustomerID, {
			status: [this.enums.ACTIVE_LOAN, this.enums.WARNING_LOAN, this.enums.BAD_DEBT_LOAN, this.enums.SETTLED_LOAN],
			schemes: ['EPF'],
			withLegacyEPF: true,
			sharedProfileId: customer.SharedProfileId,
			includedSharedProfile: true
		});
		if (this.previousEPFLoans.length == 0) {
			this.sharedService.openAlert('This profile do not have active EPF loan(s), only can help key in customer details', ALERT_TYPE.DANGER);
		} else {
			this.distributeReturnAmount();
		}
	}

	resetEverything() {
		this.amount = 0;
		this.returnBank = this.returnBank == '' ? this.defaultBank.Description : this.returnBank;
		this.branchDistributionList = [];
		this.remark = '';
		this.needRefund = false;
		this.isShared = false;

		this.resetRefund();
		this.cdr.detectChanges();
	}

	resetRefund() {
		this.refundAmount = 0;
		this.removeBank();
	}

	distributeReturnAmount() {
		this.amount = 0;
		this.branchDistributionList = [];

		//TEST DATA
		// let data = [{ "arrearCount": 0, "arrearPaid": 0, "balance": 28305, "commissionRateLimit": 6, "companyCode": "TEST COMP 3 (JULIAN)", "companyId": 127, "customerId": 198025, "customerName": "ALI BIN MOHAMMAD", "dateCreated": "2026-03-03T00:00:00+08:00", "discount": 0, "epf": false, "extraInterest": 0, "handler": "leebryan", "icNumber": "7208130251234", "id": 458174, "interestRate": 5, "issuer": "tanjulian", "loanCode": "458174", "loanGroupId": 377343, "mainCompanyCode": "TEST (BRYAN)", "mainCompanyId": 124, "mainCustomerId": 197953, "monthlyInterest": 0, "monthlyPayment": 1665, "principal": 15300, "principalPaid": 0, "processingCharge": 1530, "profileId": 199103, "receiptNumber": "P2232786", "repayment": 0, "scheme": "EPF", "settlementCharges": { "stamp": 170.00, "serviceCharge": 51.00, "handlingCharge": 0.00, "extras": 0.00 }, "sharedCompanies": [124, 127], "status": 1, "term": 17 }, { "arrearCount": 0, "arrearPaid": 0, "balance": 28305, "commissionRateLimit": 6, "companyCode": "TEST (BRYAN)", "companyId": 124, "customerId": 197953, "customerName": "ALI BIN MOHAMMAD", "dateCreated": "2026-03-02T00:00:00+08:00", "discount": 0, "epf": false, "extraInterest": 0, "handler": "leebryan", "icNumber": "7208130251234", "id": 458194, "interestRate": 5, "issuer": "leebryan", "loanCode": "458194", "loanGroupId": 377343, "mainCompanyCode": "TEST (BRYAN)", "mainCompanyId": 124, "mainCustomerId": 197953, "monthlyInterest": 0, "monthlyPayment": 1665, "principal": 15300, "principalPaid": 0, "processingCharge": 1530, "profileId": 199031, "receiptNumber": "P2232872", "repayment": 0, "scheme": "EPF", "settlementCharges": { "stamp": 170.00, "serviceCharge": 51.00, "handlingCharge": 0.00, "extras": 0.00 }, "sharedCompanies": [124, 127], "status": 1, "term": 17 }];
		// this.previousEPFLoans = data.map(d => this.loanAdapter.adapt(d));
		// this.selectedCustomer = new GlobalCustomer("TEST CUSTOMER", "961105105569", "TESTCOMPANY");
		// this.remark = this.selectedCustomer.Name + " (" + this.selectedCustomer.ICNumber + ")"

		const grouped = this.previousEPFLoans.reduce(
			(acc, item) => {
				if (!acc[item.CompanyCode]) {
					acc[item.CompanyCode] = 0;
				}
				acc[item.CompanyCode] += this.sharedService.calculateEPFSettlementAmountWithCharges(item);
				return acc;
			},
			{} as Record<string, number>
		);

		Object.keys(grouped).map(branch => {
			var companyId = this.previousEPFLoans.find(l => l.CompanyCode == branch).CompanyId;

			this.branchDistributionList.push({
				appliedBranch: new Company(companyId, undefined, undefined, branch),
				amount: this.sharedService.roundTo2Dec(grouped[branch])
			});
			this.amount += this.sharedService.roundTo2Dec(grouped[branch]);
		});
	}

	openAddBankInAccountModal() {
		const modalRef = this.sharedService.openModal(AddBankInAccountComponent);

		modalRef.componentInstance.addedBank.subscribe((entry: CustomerAccount) => {
			this.bankInAccount = entry;
		});
	}

	removeBank() {
		this.bankInAccount = undefined;
	}

	constructWhatsappMessage() {
		const refundMessage =
			this.needRefund ?
				'*REFUND TO: ' +
				this.bankInAccount.HolderName +
				' (' +
				this.bankInAccount.Bank +
				'-' +
				this.bankInAccount.AccountNumber +
				')*\n' +
				'AMOUNT: RM ' +
				this.sharedService.roundTo2Dec(this.refundAmount)
			:	'';

		const returnMessage =
			'BRANCH: ' +
			this.branchDistributionList.map(b => b.appliedBranch.CompanyCode).join(',') +
			'\n' +
			'RETURN TO BANK: ' +
			this.returnBank +
			'\n' +
			'*AMOUNT: RM ' +
			this.sharedService.roundTo2Dec(this.amount) +
			'*\n' +
			'*REMARK: ' +
			this.remark +
			'*\n';

		var distributionMessage = '';

		this.branchDistributionList.forEach(b => {
			distributionMessage += b.appliedBranch.CompanyCode + '= RM ' + this.sharedService.roundTo2Dec(b.amount) + '\n';
		});

		this.finalMessage = '*#' + this.uuid + ' - RETURN*\n' + returnMessage + '\n' + distributionMessage + '\n' + refundMessage;
	}

	async submit() {
		this.disableSubmit = true;
		let error = this.checkError();

		if (error.length == 0) {
			if (this.selectedReturnOpt == 'Office Cash') {
				this.branchDistributionList.push({
					appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
					amount: this.amount
				});
			} else {
				if (this.previousEPFLoans.length == 0) {
					if (this.branchDistributionList.length == 0) {
						this.branchDistributionList.push({
							appliedBranch: new Company(this.companyId, undefined, undefined, this.companyCode),
							amount: this.amount
						});
					}
					this.remark = this.remark + '(KERJA CUSTOMER)';
				} else {
					this.branchDistributionList = await this.checkAndProcessDistributionList();
				}
			}
			this.confirmBeforeSubmittingRequest();
		} else {
			this.sharedService.openAlert('Please fix following error:\n' + error.join('\n'), ALERT_TYPE.DANGER);
			this.disableSubmit = false;
		}
	}

	async checkAndProcessDistributionList() {
		return this.branchDistributionList.filter(e => e.amount !== 0);
	}

	showMessage() {
		//show message
		this.constructWhatsappMessage();
		const modalref = this.sharedService.openModal(MessageClipboardComponent, 'largeModal');
		modalref.componentInstance.value = this.finalMessage;
		modalref.componentInstance.isModal = true;
		modalref.componentInstance.modalTitle = 'Asset Request Message - Return';
	}

	async constructSheetDetails() {
		var sheetRequestList: any[] = [];

		const uuidV4 = window.crypto.randomUUID();
		this.uuid = uuidV4.split('-')[0] + '-' + uuidV4.split('-')[1];
		const now = new Date();
		const timestamp = this.datepipe.transform(now, 'yyyy-MM-dd HH:mm:ss', '+0800');

		for (const [index, e] of this.branchDistributionList.entries()) {
			let refundDetails =
				this.refundAmount > 0 ? `[REFUND RM ${this.refundAmount} to ${this.bankInAccount.HolderName} (${this.bankInAccount.Bank} ${this.bankInAccount.AccountNumber})]` : '';
			let acctDetails = `${this.remark} -${this.selectedReturnOpt} = ${refundDetails}`;
			let cashInOfficeDetails = '';

			let mbbMaster = index == 0 ? this.sharedService.getListTotalWithKey(this.branchDistributionList, 'amount') : '';

			let sd = new SheetDetails();
			sd.Type = this.enums.TYPE_RETURN; //hard coded

			if (this.returnBank == this.defaultBank.Description) {
				sd.BankName = this.defaultBank.Description + '@' + this.defaultBank.Code;
			} else sd.BankName = this.returnBank;

			sd.MbbMaster = mbbMaster;
			sd.OtherBankMaster = '';

			var sqlInfo = await this.companyService.getCompanySQLInfo(e.appliedBranch.ID);
			const santizedRemark = this.remark.replace(';', ',');

			sd.BranchName = e.appliedBranch.CompanyCode + '@' + sqlInfo.GLCode;
			sd.AccountDetails = acctDetails;
			sd.CustomerName = '';
			sd.LineAmount = e.amount;
			sd.CashInOffice = cashInOfficeDetails;
			sd.Remark = santizedRemark;
			sd.Timestamp = timestamp;
			sd.Uuid = this.uuid;
			sd.RequestedBy = this.loggedInUser;
			sd.Checker = 'DONE'; // HARD CODED

			//convert all class properties into value in array
			//in this case property order is important!!
			const s = Object.values(sd);
			sheetRequestList.push(s);
		}

		if (this.refundAmount > 0) {
			var rl = await this.addRefundLine(timestamp);
			sheetRequestList.push(rl);
		}

		return sheetRequestList;
	}

	async addRefundLine(timestamp: string) {
		let acctDetails = `${this.bankInAccount.HolderName} (${this.bankInAccount.Bank} ${this.bankInAccount.AccountNumber})`;
		let cashInOfficeDetails = '';

		let mbbMaster = this.refundAmount;

		let sd = new SheetDetails();
		sd.Type = this.enums.TYPE_REFUND; //hard coded
		sd.MbbMaster = mbbMaster;
		sd.OtherBankMaster = '';

		if (this.returnBank == this.defaultBank.Description) {
			sd.BankName = this.defaultBank.Description + '@' + this.defaultBank.Code;
		} else sd.BankName = this.returnBank;

		var sqlInfo = await this.companyService.getCompanySQLInfo(this.companyId);
		sd.BranchName = this.companyCode + '@' + sqlInfo.GLCode;
		sd.AccountDetails = acctDetails;
		sd.CustomerName = '';
		sd.LineAmount = this.refundAmount;
		sd.CashInOffice = cashInOfficeDetails;
		sd.Remark = this.remark;
		sd.Timestamp = timestamp;
		sd.Uuid = this.uuid;
		sd.RequestedBy = this.loggedInUser;

		//convert all class properties into value in array
		//in this case property order is important!!
		const s = Object.values(sd);
		return s;
	}

	async addToSheetAndConstructMessgae() {
		const data = await this.constructSheetDetails();
		const result = await this.sheetRequestService.postAsstSheetRequest(data);
		if (result != undefined) {
			this.showMessage();
		}
		this.activeModal.close();
	}

	confirmBeforeSubmittingRequest() {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		const withRefund = this.needRefund ? ' and REFUND RM ' + this.sharedService.roundTo2Dec(this.refundAmount) : '';
		modalRef.componentInstance.message = 'You are going to RETURN RM ' + this.sharedService.roundTo2Dec(this.amount) + withRefund + ', are you sure?';

		modalRef.result.then(confirm => {
			if (confirm) this.addToSheetAndConstructMessgae();
		});
	}

	checkError() {
		let error: string[] = new Array();

		if (this.amount == 0 || this.amount == undefined) error.push('- Return Amount');
		if (this.remark == undefined || this.remark == '') error.push('-Remark');
		if (this.returnBank == '' || this.returnBank == undefined) error.push('-Return Bank Name');

		if (this.needRefund) {
			if (this.bankInAccount == undefined) error.push('-Refund Bank In Account');
			if (this.refundAmount == 0) error.push('-Refund Amount');
			// else if (this.refundAmount > this.amount) {
			// 	error.push('-Refund Amount more than Returned Amount');
			// }
		}

		if (this.selectedCustomer != undefined && this.previousEPFLoans.length > 0 && this.branchDistributionList.length == 0)
			error.push('- For this selected customer cannot leave the distribution empty');
		if (this.branchDistributionList.length > 0) {
			const totalInList = this.branchDistributionList.reduce((sum, acc) => sum + acc.amount, 0);

			if (this.sharedService.roundTo2Dec(totalInList) != this.sharedService.roundTo2Dec(this.amount)) error.push('- Branch return amount not equal to total return amount!');
		}

		return error;
	}
}
